import { LocaleTypes } from '@/types/LocaleTypes'

import {
	OGTagsReportData,
	OgImages,
	ScrapedOGTags,
	ScrapedResults,
	SupportedLocales
} from './types'

const imagesUrls: OgImages = {
	prod: [
		'https://www-cdn.bigcommerce.com/assets/_1200x630_crop_center-center_82_none/article-thumbnail-sell-online-page-builder-bigcommerce_2022-06-28-064618_bxhd.png?mtime=1665691587',
		'https://www-cdn.bigcommerce.com/assets/_1200x630_crop_center-center_82_none/BigCommerce-Social-Image-Generic-Facebook.jpg?mtime=1681929501',
		'https://www-cdn.bigcommerce.com/assets/_1200x630_crop_center-center_82_none/Article_Thumbnail_Ecommerce_Website.jpg?mtime=1681929277',
		'https://www-cdn.bigcommerce.com/assets/BigCommerce-Social-Image-Generic-Facebook.jpg',
		'https://www-cdn.bigcommerce.com/assets/_1200x630_crop_center-center_82_none/article-thumbnail-sell-online-page-builder-bigcommerce_2022-06-28-064618_bxhd.png?mtime=1665691587',
		'https://www-cdn.bigcommerce.com/assets/_1200x630_crop_center-center_82_none/article-thumbnail-affiliate-marketing-social-bigcommerce_2022-06-27-075739_vvhs.png?mtime=1665691692'
	],
	stg: [
		'https://storage.googleapis.com/s.mkswft.com/RmlsZTo4ZmJiYTYzMy1jOGUwLTQ4ZWEtOTRiNy1iZmUyZjRkYWIwMDU=/BigCommerce-Social-Image-Generic-Facebook.jpg'
	]
}

const LocalesByCountry: SupportedLocales = {
	au: [LocaleTypes.en_AU],
	at: [LocaleTypes.de_AT],
	dk: [LocaleTypes.da_DK],
	fr: [LocaleTypes.fr_FR],
	de: [LocaleTypes.de_DE],
	it: [LocaleTypes.it_IT],
	mx: [LocaleTypes.es_LA, LocaleTypes.es_MX],
	nl: [LocaleTypes.nl_NL],
	no: [LocaleTypes.nb_NO],
	sg: [LocaleTypes.en_SG],
	es: [LocaleTypes.es_ES],
	se: [LocaleTypes.sv_SE],
	uk: [LocaleTypes.en_GB],
	us: [LocaleTypes.en_US]
}

const emptyMetadata = {
	prodUrl: '',
	stgUrl: '',
	title: '',
	status: '',
	webXP: '',
	description: '',
	robots: '',
	language: '',
	canonical: '',
	URLStructure: '',
	internalLinks: '',
	error: ''
}
const emptyOGData: OGTagsReportData = {
	prodUrl: '',
	stgUrl: '',
	status: '',
	webXP: '',
	prodTitle: '',
	stgTitle: '',
	matchTitle: '',
	prodDescription: '',
	stgDescription: '',
	matchDescription: '',
	locale: '',
	url: '',
	site_name: '',
	image: '',
	type: '',
	error: ''
}
const emptyOGTags: ScrapedOGTags = {
	prodUrl: '',
	stgUrl: '',
	title: '',
	status: '',
	webXP: '',
	description: '',
	locale: '',
	url: '',
	site_name: '',
	image: '',
	type: '',
	error: ''
}
const emptyResults: ScrapedResults = {
	metadata: emptyMetadata,
	ogTags: emptyOGData
}
const AvailableTags: string[] = [
	'description',
	'image',
	'title',
	'url',
	'type',
	'site_name',
	'locale'
]

export {
	AvailableTags,
	emptyResults,
	emptyOGTags,
	emptyOGData,
	emptyMetadata,
	imagesUrls,
	LocalesByCountry
}

export const BigCommerceLogotype =
	'https://dam.bigcommerce.com/m/a26d97157c894cd/original/BigCommerce-Logo-Black.png'
